import { h } from 'preact'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import styles from './LinkButton.module.scss'

const LinkButton = ({ title, onClick, className, ...props }) => {
  const classes = classNames(className, styles.linkButton)

  return (
    <button type="button" className={classes} onClick={onClick} {...props}>
      {title}
    </button>
  )
}

LinkButton.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default LinkButton
